import React, { useState } from 'react';
import axios from '../Axiosinstance';
import { useNavigate } from 'react-router-dom';
import { Box, Card, Typography, TextField, Button, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function PasswordForm({ email }) {
    const [input1Value, setInput1Value] = useState('');
    const [input2Value, setInput2Value] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const navigate = useNavigate();

    const handleInputChange = (setter) => (e) => setter(e.target.value);

    const isStrongPassword = (password) => {
        const minLength = 8;
        const containsUppercase = /[A-Z]/.test(password);
        const containsLowercase = /[a-z]/.test(password);
        const containsNumber = /[0-9]/.test(password);
        const containsSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]/.test(password);

        return (
            password.length >= minLength &&
            containsUppercase &&
            containsLowercase &&
            containsNumber &&
            containsSpecialChar
        );
    };

    const handleButtonClick = () => {

        if (!input1Value || !input2Value) {
            setError('Passwords cannot be empty.');
            setSuccessMessage('');
            return;
        }
        
        if (input1Value !== input2Value) {
            setError('Passwords do not match.');
            setSuccessMessage('');
            return;
        }


        axios.post('/reset-password', { email, newPassword: input1Value })
            .then(() => {
                setError('');
                setSuccessMessage('Password reset successful.');
                navigate("/login");
            })
            .catch(() => {
                setError('Error resetting password. Please try again.');
                setSuccessMessage('');
            });
    };

    return (
        <Box display="flex" justifyContent="center" alignItems="center">
        <Card sx={{ p: 4, maxWidth: 500, width: "100%", textAlign: "center" }}>
          <Typography variant="h6" gutterBottom>
            Reset Password
          </Typography>
  
          {/* New Password Field */}
          <TextField
            label="New Password"
            type={showPassword ? "text" : "password"}
            fullWidth
            required
            margin="normal"
            value={input1Value}
            onChange={handleInputChange(setInput1Value)}
            error={input1Value && !isStrongPassword(input1Value)}
            helperText={input1Value && !isStrongPassword(input1Value) ? "Please enter a strong password." : ""}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
  
          {/* Confirm Password Field */}
          <TextField
            label="Confirm Password"
            type={showConfirmPassword ? "text" : "password"}
            fullWidth
            required
            margin="normal"
            value={input2Value}
            onChange={handleInputChange(setInput2Value)}
            error={input2Value && input1Value !== input2Value}
            helperText={input2Value && input1Value !== input2Value ? "Passwords do not match." : ""}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowConfirmPassword((prev) => !prev)} edge="end">
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
  
          {/* Submit Button */}
          <Button variant="contained" color="primary" onClick={handleButtonClick} sx={{ mt: 2, width: "100%" }}>
            Submit
          </Button>
        </Card>
      </Box>
    
    );
}

export default PasswordForm;
